import { useEffect, useState, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DashboardLayout from "../../controls/DashboardLayout";
import DashboardNavbar from "../../controls/DashboardNavbar";
import MDBox from "../../controls/MDBox";
import { Grid } from "@mui/material";
import { Card } from "react-bootstrap";
import MDTypography from "../../controls/MDTypography";
import ManualAyuda from "../../controls/ManualAyuda";
import MDButton from "../../controls/MDButton";
import DataTable from "../../controls/Tables/DataTable";
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import StarIcon from '@mui/icons-material/Star';
import { postData, pathData, deleteData, getData } from "../../Utils/Http/api";
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Tooltip from '@mui/material/Tooltip';

function JudEventoRestriccionListar() {
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [dataVersion, setDataVersion] = useState(0);
    const [openDialog, setOpenDialog] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);

    const [subEstadosRequeridos] = useState([
        { id: 0, label: "SISTEMA" },
        { id: 1, label: "GESTION" },
        { id: 2, label: "CAUTELAR" },
        { id: 3, label: "PROCESAL" }
    ]);
    const [subEstados] = useState([
        { id: 1, label: "GESTION" },
        { id: 2, label: "CAUTELAR" },
        { id: 3, label: "PROCESAL" }
    ]);
    
    const [estados, setEstados] = useState([]);
    const [eventosTipo, setEventosTipo] = useState([]);
    const [restriccionesTipo, setRestriccionesTipo] = useState([]);

    // Filtros para el listar
    const [filtroSubEstado, setFiltroSubEstado] = useState(null);
    const [filtroEstado, setFiltroEstado] = useState(null);
    const [filtroEventoTipo, setFiltroEventoTipo] = useState(null);
    const [filtroActivo, setFiltroActivo] = useState(true);

    const [selectedSubEstado, setSelectedSubEstado] = useState(null);
    const [selectedEstado, setSelectedEstado] = useState(null);
    const [selectedEventoTipo, setSelectedEventoTipo] = useState(null);
    const [selectedRestriccionTipo, setSelectedRestriccionTipo] = useState(null);
    const [selectedEventoRequerido, setSelectedEventoRequerido] = useState([]);
    
    // Filtros para el destino (evento/estado requerido)
    const [selectedSubEstado2, setSelectedSubEstado2] = useState(null);
    const [selectedEstado2, setSelectedEstado2] = useState(null);
    const [mensajeRestriccion, setMensajeRestriccion] = useState("");
    const [grupoOr, setGrupoOr] = useState(false);
    const [activo, setActivo] = useState(true);

    const [snackbar, setSnackbar] = useState({ open: false, msg: '', severity: 'success' });
    const [openDelete, setOpenDelete] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    const fetchEstados = async () => {
        try {
            const res = await getData('/JudEstadoListar', { estado: "", subEstado: "" });
            const list = res?.value || [];
            setEstados(list.map(e => ({ id: e.idJudEstado, label: e.estado, subEstado: e.subEstado })));
        } catch (ex) {
            console.error('Error cargando estados', ex);
        }
    };

    const fetchEventosTipo = async () => {
        try {
            const res = await getData('/JudEventoTipoListar', { tipoEvento: "", estado: "", subEstado: "" });
            const list = res?.value || [];
            setEventosTipo(list.map(e => ({
                id: e.idJudEventoTipo,
                label: e.tipoEvento,
                estado: e.estado,
                subEstado: e.subEstado
            })));
        } catch (ex) {
            console.error('Error cargando tipos de evento', ex);
        }
    };

    const fetchRestriccionesTipo = async () => {
        try {
            const res = await getData('/JudEventoRestriccionTipoListar', {});
            const list = res?.value || [];
            setRestriccionesTipo(list.map(r => ({
                id: r.idJudEventoRestriccionTipo,
                label: r.tipoRestriccion,
                observaciones: r.observaciones,
                restringePor: r.restringePor
            })));
        } catch (ex) {
            console.error('Error cargando tipos de restricción', ex);
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const params = {
                IDJudSubEstado: filtroSubEstado?.id || 0,
                IDJudEstado: filtroEstado?.id || 0,
                IDJudEventoTipo: filtroEventoTipo?.id || 0,
                Activo: filtroActivo ? 1 : 0
            };
            const res = await getData('/JudEventoRestriccionListar', params);
            const list = res?.value || [];

            const newColumns = [
                { Header: 'Evento y Estado', accessor: 'detalle', align: 'left', width: '30%' },
                { Header: 'Restricción', accessor: 'restriccion', align: 'left', width: '30%' },
                { Header: 'Observaciones', accessor: 'observaciones', align: 'left', width: '20%' },
                { Header: 'Agrupa', accessor: 'grupo', align: 'center', width: '5%' },
                { Header: 'Activo', accessor: 'estadoActivo', align: 'center', width: '5%' },
                { Header: 'Acciones', accessor: 'action', align: 'center', width: '10%' }
            ];

            const data = list.map(item => {
                const detalle = (
                    <MDBox>
                        <MDTypography variant="body2" color="text" fontWeight="medium">
                            {item.tipoEvento}
                        </MDTypography>
                        <MDTypography variant="caption" color="info" fontWeight="regular" fontSize="0.7rem">
                            {item.estado} ({item.subEstado})
                        </MDTypography>
                    </MDBox>
                );
                const restriccion = (
                    <MDBox>
                        <MDTypography variant="caption" color="text" fontWeight="medium" fontSize="0.55rem">
                            {item.tipoRestriccion}
                        </MDTypography>
                        <MDTypography variant="caption" color="info" fontWeight="medium" fontSize="0.7rem" sx={{ display: 'block', mt: 0.7 }}>
                            {item.tipoEventoRequerido}
                        </MDTypography>
                    </MDBox>
                );
                const observaciones = (
                    <Tooltip title={item.mensajeDeRestriccion || ''} arrow placement="top">
                        <MDBox sx={{ cursor: 'pointer' }}>
                            <MDTypography
                                variant="caption"
                                color="text"
                            >
                                {item.mensajeDeRestriccion
                                    ? (item.mensajeDeRestriccion.length > 50
                                        ? item.mensajeDeRestriccion.substring(0, 50) + '...'
                                        : item.mensajeDeRestriccion)
                                    : '-'}
                            </MDTypography>
                        </MDBox>
                    </Tooltip>
                );
                const grupo = (
                    <MDTypography variant="body2" color={item.grupoOr ? "success" : "error"} fontWeight="medium">
                        {item.grupoOr ? "Si" : "No"}
                    </MDTypography>
                );
                const estadoActivo = (
                    <MDTypography variant="body2" color={item.activo ? "success" : "error"} fontWeight="medium">
                        {item.activo ? "Si" : "No"}
                    </MDTypography>
                );
                const action = (
                    <MDBox display="flex" gap={1} alignItems="center" justifyContent="center">
                        <IconButton
                            size="small"
                            onClick={() => handleOpenEdit(item)}
                            aria-label="editar"
                        >
                            <EditIcon color="info" />
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={() => { setDeleteId(item.idJudEventoRestriccion); setOpenDelete(true); }}
                            aria-label="eliminar"
                        >
                            <DeleteIcon color="error" />
                        </IconButton>
                    </MDBox>
                );
                return {
                    id: item.idJudEventoRestriccion,
                    detalle,
                    restriccion,
                    observaciones,
                    grupo,
                    estadoActivo,
                    action
                };
            });

            setColumns(newColumns);
            setRows([...data]);
        } catch (ex) {
            console.error('Error cargando restricciones de evento', ex);
            setSnackbar({ open: true, msg: 'Error al cargar las restricciones de evento', severity: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEstados();
        fetchEventosTipo();
        fetchRestriccionesTipo();
    }, []);

    useEffect(() => {
        if (estados.length > 0 && eventosTipo.length > 0 && restriccionesTipo.length > 0) {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshKey, estados, eventosTipo, restriccionesTipo, filtroSubEstado, filtroEstado, filtroEventoTipo, filtroActivo]);

    const handleOpenAdd = () => {
        setEditMode(false);
        setCurrentItem(null);
        setSelectedSubEstado(null);
        setSelectedEstado(null);
        setSelectedEventoTipo(null);
        setSelectedRestriccionTipo(null);
        setSelectedEventoRequerido([]);
        setSelectedSubEstado2(null);
        setSelectedEstado2(null);
        setMensajeRestriccion("");
        setGrupoOr(0);
        setActivo(true);
        setOpenDialog(true);
    };

    const handleOpenEdit = async (item) => {
        setEditMode(true);
        setCurrentItem(item);

        // Cargar datos de origen
        const subEstado = subEstados.find(s => s.label === item.subEstado);
        // No permitir SISTEMA (id: 0) en la sección de origen
        setSelectedSubEstado((subEstado && subEstado.id !== 0) ? subEstado : null);

        const estado = estados.find(e => e.label === item.estado);
        setSelectedEstado(estado || null);

        const eventoTipo = eventosTipo.find(e => e.id === item.idJudEventoTipo);
        setSelectedEventoTipo(eventoTipo || null);

        const restriccionTipo = restriccionesTipo.find(r => r.id === item.idJudEventoRestriccionTipo);
        setSelectedRestriccionTipo(restriccionTipo || null);

        // Cargar datos de destino
        // Si el item tiene idJudEventoRequerido, convertirlo a array
        // En edición, el backend debería devolver un array, pero por si acaso manejamos ambos casos
        let eventosRequeridos = [];
        if (Array.isArray(item.idJudEventoRequerido)) {
            eventosRequeridos = item.idJudEventoRequerido.map(id => eventosTipo.find(e => e.id === id)).filter(e => e);
        } else if (item.idJudEventoRequerido) {
            const eventoRequerido = eventosTipo.find(e => e.id === item.idJudEventoRequerido);
            if (eventoRequerido) eventosRequeridos = [eventoRequerido];
        }
        setSelectedEventoRequerido(eventosRequeridos);

        // Para cargar correctamente los filtros del destino, necesitamos el estado del evento requerido
        const eventoRequerido = eventosRequeridos.length > 0 ? eventosRequeridos[0] : null;
        if (eventoRequerido) {
            const estadoRequerido = estados.find(e => e.label === eventoRequerido.estado);
            setSelectedEstado2(estadoRequerido || null);
            
            if (estadoRequerido) {
                const subEstadoRequerido = subEstadosRequeridos.find(s => s.label === estadoRequerido.subEstado);
                setSelectedSubEstado2(subEstadoRequerido || null);
            }
        }

        setMensajeRestriccion(item.mensajeDeRestriccion || "");
        setGrupoOr(Boolean(item.grupoOr));
        setActivo(Boolean(item.activo));
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setCurrentItem(null);
        setSelectedSubEstado(null);
        setSelectedEstado(null);
        setSelectedEventoTipo(null);
        setSelectedRestriccionTipo(null);
        setSelectedEventoRequerido([]);
        setSelectedSubEstado2(null);
        setSelectedEstado2(null);
        setMensajeRestriccion("");
        setGrupoOr(false);
        setActivo(true);
    };

    const handleSubEstadoChange = (e, newValue) => {
        setSelectedSubEstado(newValue);
        setSelectedEstado(null);
        setSelectedEventoTipo(null);
    };

    const handleEstadoChange = (e, newValue) => {
        setSelectedEstado(newValue);
        setSelectedEventoTipo(null);
    };

    const getEstadosFiltrados = () => {
        if (!selectedSubEstado) return [];
        return estados.filter(e => e.subEstado === selectedSubEstado.label);
    };

    const getEventosTipoFiltrados = () => {
        if (!selectedEstado) return [];
        return eventosTipo.filter(e => e.estado === selectedEstado.label);
    };

    const getEstadosFiltrados2 = () => {
        if (!selectedSubEstado2) return [];
        // Si es SISTEMA (id: 0), devolver una opción especial
        if (selectedSubEstado2.id === 0) {
            return [{ id: 0, label: "SISTEMA", subEstado: "SISTEMA" }];
        }
        return estados.filter(e => e.subEstado === selectedSubEstado2.label);
    };

    const getEventosTipoFiltrados2 = () => {
        if (!selectedEstado2) return [];
        // Si es SISTEMA (id: 0), buscar eventos con estado SISTEMA
        if (selectedEstado2.id === 0) {
            return eventosTipo.filter(e => e.estado === "SISTEMA");
        }
        return eventosTipo.filter(e => e.estado === selectedEstado2.label);
    };

    const handleSubEstado2Change = (e, newValue) => {
        setSelectedSubEstado2(newValue);
        setSelectedEstado2(null);
        setSelectedEventoRequerido([]);
    };

    const handleEstado2Change = (e, newValue) => {
        setSelectedEstado2(newValue);
        setSelectedEventoRequerido([]);
    };

    const restringePorEvento = () => {
        return selectedRestriccionTipo?.restringePor === "EVENTO";
    };

    const restringePorEstado = () => {
        return selectedRestriccionTipo?.restringePor === "ESTADO";
    };

    const handleSave = async () => {
        // Validaciones comunes
        if (!selectedRestriccionTipo) {
            setSnackbar({ open: true, msg: 'Debe seleccionar un tipo de restricción', severity: 'warning' });
            return;
        }
        if (!selectedSubEstado) {
            setSnackbar({ open: true, msg: 'Debe seleccionar un sub estado de origen', severity: 'warning' });
            return;
        }
        if (!selectedEstado) {
            setSnackbar({ open: true, msg: 'Debe seleccionar un estado de origen', severity: 'warning' });
            return;
        }

        // Validaciones específicas según RestringePor
        if (restringePorEvento()) {
            // Modo EVENTO: validar que haya tipo de evento en origen y destino
            if (!selectedEventoTipo) {
                setSnackbar({ open: true, msg: 'Debe seleccionar un tipo de evento de origen', severity: 'warning' });
                return;
            }
            if (!selectedSubEstado2) {
                setSnackbar({ open: true, msg: 'Debe seleccionar un sub estado requerido', severity: 'warning' });
                return;
            }
            if (!selectedEstado2) {
                setSnackbar({ open: true, msg: 'Debe seleccionar un estado requerido', severity: 'warning' });
                return;
            }
            if (!selectedEventoRequerido || selectedEventoRequerido.length === 0) {
                setSnackbar({ open: true, msg: 'Debe seleccionar al menos un tipo de evento requerido', severity: 'warning' });
                return;
            }
        } else if (restringePorEstado()) {
            // Modo ESTADO: validar que haya estado en destino
            if (!selectedSubEstado2) {
                setSnackbar({ open: true, msg: 'Debe seleccionar un sub estado requerido', severity: 'warning' });
                return;
            }
            if (!selectedEstado2) {
                setSnackbar({ open: true, msg: 'Debe seleccionar un estado requerido', severity: 'warning' });
                return;
            }
        }

        try {
            // Preparar payload según el modo
            let idJudEventoTipoOrigen = null;
            let idsJudEventoTipoRequerido = [];

            if (restringePorEvento()) {
                // En modo EVENTO, usar los tipos de evento seleccionados
                idJudEventoTipoOrigen = selectedEventoTipo?.id;
                // Convertir array de objetos a array de IDs
                idsJudEventoTipoRequerido = selectedEventoRequerido.map(e => e.id);
            } else if (restringePorEstado()) {
                // En modo ESTADO, buscar el primer tipo de evento de cada estado
                // (o usar null si la API lo permite)
                const eventoOrigen = eventosTipo.find(e => e.estado === selectedEstado.label);
                idJudEventoTipoOrigen = eventoOrigen?.id;
                // Para modo ESTADO, si se seleccionaron eventos, usar esos IDs
                if (selectedEventoRequerido && selectedEventoRequerido.length > 0) {
                    idsJudEventoTipoRequerido = selectedEventoRequerido.map(e => e.id);
                } else {
                    const eventoRequerido = eventosTipo.find(e => e.estado === selectedEstado2.label);
                    if (eventoRequerido) idsJudEventoTipoRequerido = [eventoRequerido.id];
                }
            }

            if (editMode) {
                const payload = {
                    idJudEventoRestriccion: currentItem.idJudEventoRestriccion,
                    idJudSubEstado: selectedSubEstado.id,
                    idJudEstado: selectedEstado.id,
                    idJudEventoTipo: idJudEventoTipoOrigen,
                    idJudEventoRestriccionTipo: selectedRestriccionTipo.id,
                    IDJudEventoRequerido: idsJudEventoTipoRequerido,
                    mensajeDeRestriccion: mensajeRestriccion,
                    grupoOr: (selectedRestriccionTipo?.id === 3 || selectedRestriccionTipo?.id === 4) ? grupoOr : false,
                    activo: activo
                };
                const res = await pathData(`/JudEventoRestriccionUpdate`, payload);
                if (res?.isSuccess) {
                    // Actualizar el registro en el estado local
                    const updatedItem = {
                        idJudEventoRestriccion: currentItem.idJudEventoRestriccion,
                        tipoEvento: selectedEventoTipo?.label || '',
                        estado: selectedEstado?.label || '',
                        subEstado: selectedSubEstado?.label || '',
                        tipoRestriccion: selectedRestriccionTipo?.label || '',
                        tipoEventoRequerido: selectedEventoRequerido.length > 0 ? selectedEventoRequerido.map(e => e.label).join(', ') : '',
                        mensajeDeRestriccion: mensajeRestriccion,
                        grupoOr: (selectedRestriccionTipo?.id === 3 || selectedRestriccionTipo?.id === 4) ? grupoOr : false,
                        activo: activo
                    };

                    // Reconstruir el row con los nuevos datos
                    const detalle = (
                        <MDBox>
                            <MDTypography variant="body2" color="text" fontWeight="medium">
                                {updatedItem.tipoEvento}
                            </MDTypography>
                            <MDTypography variant="caption" color="info" fontWeight="regular" fontSize="0.7rem">
                                {updatedItem.estado} ({updatedItem.subEstado})
                            </MDTypography>
                        </MDBox>
                    );
                    const restriccion = (
                        <MDBox>
                            <MDTypography variant="caption" color="text" fontWeight="medium" fontSize="0.55rem">
                                {updatedItem.tipoRestriccion}
                            </MDTypography>
                            <MDTypography variant="caption" color="info" fontWeight="medium" fontSize="0.7rem" sx={{ display: 'block', mt: 0.7 }}>
                                {updatedItem.tipoEventoRequerido}
                            </MDTypography>
                        </MDBox>
                    );
                    const observaciones = (
                        <Tooltip title={updatedItem.mensajeDeRestriccion || ''} arrow placement="top">
                            <MDBox sx={{ cursor: 'pointer' }}>
                                <MDTypography variant="caption" color="text">
                                    {updatedItem.mensajeDeRestriccion
                                        ? (updatedItem.mensajeDeRestriccion.length > 50
                                            ? updatedItem.mensajeDeRestriccion.substring(0, 50) + '...'
                                            : updatedItem.mensajeDeRestriccion)
                                        : '-'}
                                </MDTypography>
                            </MDBox>
                        </Tooltip>
                    );
                    const grupo = (
                        <MDTypography variant="body2" color={updatedItem.grupoOr ? "success" : "error"} fontWeight="medium">
                            {updatedItem.grupoOr ? "Si" : "No"}
                        </MDTypography>
                    );
                    const estadoActivo = (
                        <MDTypography variant="body2" color={updatedItem.activo ? "success" : "error"} fontWeight="medium">
                            {updatedItem.activo ? "Si" : "No"}
                        </MDTypography>
                    );
                    const action = (
                        <MDBox display="flex" gap={1} alignItems="center" justifyContent="center">
                            <IconButton
                                size="small"
                                onClick={() => handleOpenEdit({...updatedItem, idJudEventoTipo: selectedEventoTipo?.id, idJudEventoRestriccionTipo: selectedRestriccionTipo?.id, idJudEventoRequerido: idsJudEventoTipoRequerido})}
                                aria-label="editar"
                            >
                                <EditIcon color="info" />
                            </IconButton>
                            <IconButton
                                size="small"
                                onClick={() => { setDeleteId(updatedItem.idJudEventoRestriccion); setOpenDelete(true); }}
                                aria-label="eliminar"
                            >
                                <DeleteIcon color="error" />
                            </IconButton>
                        </MDBox>
                    );

                    const updatedRow = {
                        id: updatedItem.idJudEventoRestriccion,
                        detalle,
                        restriccion,
                        observaciones,
                        grupo,
                        estadoActivo,
                        action
                    };

                    // Actualizar el row en el array
                    setRows(prevRows => prevRows.map(row => 
                        row.id === currentItem.idJudEventoRestriccion ? updatedRow : row
                    ));

                    setSnackbar({ open: true, msg: 'Restricción actualizada correctamente', severity: 'success' });
                    handleCloseDialog();
                } else {
                    setSnackbar({ open: true, msg: res?.error || 'Error actualizando restricción', severity: 'error' });
                }
            } else {
                const payload = {
                    idJudSubEstado: selectedSubEstado.id,
                    idJudEstado: selectedEstado.id,
                    idJudEventoTipo: idJudEventoTipoOrigen,
                    idJudEventoRestriccionTipo: selectedRestriccionTipo.id,
                    IDJudEventoRequerido: idsJudEventoTipoRequerido,
                    mensajeDeRestriccion: mensajeRestriccion,
                    grupoOr: (selectedRestriccionTipo?.id === 3 || selectedRestriccionTipo?.id === 4) ? grupoOr : false,
                    activo: activo
                };
                const res = await postData('/JudEventoRestriccionAlta', payload);
                if (res?.isSuccess) {
                    setSnackbar({ open: true, msg: 'Restricción creada correctamente', severity: 'success' });
                    handleCloseDialog();
                    setDataVersion(prev => prev + 1);
                    setRefreshKey(prev => prev + 1);
                } else {
                    setSnackbar({ open: true, msg: res?.error || 'Error creando restricción', severity: 'error' });
                }
            }
        } catch (ex) {
            console.error('Error guardando restricción', ex);
            setSnackbar({ open: true, msg: 'Error guardando restricción', severity: 'error' });
        }
    };

    const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

    const handleCancelDelete = () => {
        setDeleteId(null);
        setOpenDelete(false);
    };

    const handleConfirmDelete = async () => {
        if (!deleteId) return;
        try {
            const res = await deleteData(`/JudEventoRestriccionDelete/${deleteId}`);
            if (res?.isSuccess) {
                // Eliminar el registro del estado local sin necesidad de recargar
                setRows(prevRows => prevRows.filter(row => row.id !== deleteId));
                setSnackbar({ open: true, msg: 'Restricción eliminada correctamente', severity: 'success' });
                setOpenDelete(false);
                setDeleteId(null);
            } else {
                setSnackbar({ open: true, msg: res?.error || 'Error eliminando restricción', severity: 'error' });
            }
        } catch (ex) {
            console.error('Error eliminando restricción', ex);
            const msg = ex?.message || ex?.response?.data?.detail || 'Error eliminando restricción';
            setSnackbar({ open: true, msg, severity: 'error' });
        }
    };

    const PaperComponent = useCallback((props) => {
        return (
            <Draggable
                handle="#draggable-dialog-title"
                cancel={'[class*="MuiDialogContent-root"]'}
            >
                <Paper {...props} />
            </Draggable>
        );
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="secondary"
                                borderRadius="lg"
                                coloredShadow="secondary"
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <MDTypography variant="h6" color="white">
                                    Restricciones de Eventos Judiciales
                                </MDTypography>
                                <ManualAyuda seccion="Restricciones de Eventos" />
                            </MDBox>

                            <MDBox pt={3} py={3} px={2}>
                                <MDBox mb={3} display="flex" flexDirection="column" gap={2}>
                                    <MDBox display="flex" gap={1}>
                                        <MDButton
                                            onClick={handleOpenAdd}
                                            variant="gradient"
                                            color="success"
                                            startIcon={<AddIcon />}
                                        >
                                            Agregar Restricción
                                        </MDButton>
                                        <MDButton
                                            onClick={() => {
                                                setDataVersion(prev => prev + 1);
                                                setRefreshKey(prev => prev + 1);
                                            }}
                                            variant="outlined"
                                            color="info"
                                            startIcon={<SearchIcon />}
                                        >
                                            Buscar
                                        </MDButton>
                                    </MDBox>
                                    <MDBox display="flex" gap={2} flexWrap="wrap">
                                        <Autocomplete
                                            options={subEstados}
                                            getOptionLabel={(option) => option.label || ""}
                                            value={filtroSubEstado}
                                            onChange={(e, newValue) => {
                                                setFiltroSubEstado(newValue);
                                                setFiltroEstado(null);
                                                setFiltroEventoTipo(null);
                                            }}
                                            disableClearable={false}
                                            freeSolo={false}
                                            sx={{ minWidth: 200 }}
                                            renderInput={(params) => <TextField {...params} label="Sub Estado" size="small" inputProps={{ ...params.inputProps, readOnly: true }} />}
                                        />
                                        <Autocomplete
                                            options={filtroSubEstado ? (filtroSubEstado.id === 0 ? [{ id: 0, label: "SISTEMA", subEstado: "SISTEMA" }] : estados.filter(e => e.subEstado === filtroSubEstado.label)) : []}
                                            getOptionLabel={(option) => option.label || ""}
                                            value={filtroEstado}
                                            onChange={(e, newValue) => {
                                                setFiltroEstado(newValue);
                                                setFiltroEventoTipo(null);
                                            }}
                                            disableClearable={false}
                                            freeSolo={false}
                                            disabled={!filtroSubEstado}
                                            sx={{ minWidth: 250 }}
                                            renderInput={(params) => <TextField {...params} label="Estado" size="small" inputProps={{ ...params.inputProps, readOnly: true }} />}
                                        />
                                        <Autocomplete
                                            options={filtroEstado ? (filtroEstado.id === 0 ? eventosTipo.filter(e => e.estado === "SISTEMA") : eventosTipo.filter(e => e.estado === filtroEstado.label)) : []}
                                            getOptionLabel={(option) => option.label || ""}
                                            value={filtroEventoTipo}
                                            onChange={(e, newValue) => setFiltroEventoTipo(newValue)}
                                            disableClearable={false}
                                            freeSolo={false}
                                            disabled={!filtroEstado}
                                            sx={{ minWidth: 300 }}
                                            renderInput={(params) => <TextField {...params} label="Tipo de Evento" size="small" inputProps={{ ...params.inputProps, readOnly: true }} />}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={filtroActivo}
                                                    onChange={(e) => setFiltroActivo(e.target.checked)}
                                                    color="info"
                                                />
                                            }
                                            label="Activo"
                                        />

                                    </MDBox>
                                </MDBox>

                                {loading ? (
                                    <MDBox display="flex" justifyContent="center" alignItems="center" py={6}>
                                        <CircularProgress />
                                    </MDBox>
                                ) : (
                                    <DataTable
                                        key={`${refreshKey}-${dataVersion}`}
                                        table={{ columns, rows }}
                                        isSorted={false}
                                        showTotalEntries
                                        canSearch={false}
                                        noEndBorder
                                        pagination={{ color: 'warning', variant: 'gradient' }}
                                    />
                                )}

                                {/* Dialog Add/Edit */}
                                <Dialog
                                    open={openDialog}
                                    onClose={(event, reason) => {
                                        if (reason !== 'backdropClick') {
                                            handleCloseDialog();
                                        }
                                    }}
                                    disableEscapeKeyDown
                                    fullWidth
                                    maxWidth="md"
                                    PaperComponent={PaperComponent}
                                    aria-labelledby="draggable-dialog-title"
                                >
                                    <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                                        {editMode ? 'Editar Restricción de Evento' : 'Agregar Restricción de Evento'}
                                    </DialogTitle>
                                    <DialogContent>
                                        <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
                                            {/* Tipo de Restricción */}
                                            <Autocomplete
                                                options={restriccionesTipo}
                                                getOptionLabel={(option) => option.label || ""}
                                                value={selectedRestriccionTipo}
                                                onChange={(e, newValue) => {
                                                    setSelectedRestriccionTipo(newValue);
                                                    // Limpiar selecciones cuando cambia el tipo
                                                    setSelectedSubEstado(null);
                                                    setSelectedEstado(null);
                                                    setSelectedEventoTipo(null);
                                                    setSelectedSubEstado2(null);
                                                    setSelectedEstado2(null);
                                                    setSelectedEventoRequerido([]);
                                                    setMensajeRestriccion("");
                                                    // Grupo OR solo para tipos 3 y 4
                                                    setGrupoOr(false);
                                                    setActivo(true);
                                                }}
                                                disableClearable={false}
                                                freeSolo={false}
                                                renderInput={(params) => <TextField {...params} label="Tipo de Restricción *" inputProps={{ ...params.inputProps, readOnly: true }} />}
                                            />

                                            {selectedRestriccionTipo && (
                                                <>
                                                    {/* SECCIÓN ORIGEN */}
                                                    <MDBox sx={{ borderTop: 2, borderColor: 'divider', pt: 2, mt: 1 }}>
                                                        <MDTypography variant="h6" mb={2} color="info">
                                                            Para ir al {selectedRestriccionTipo?.restringePor || "Estado/Evento"}
                                                        </MDTypography>

                                                        {/* Filtros comunes: SubEstado y Estado */}
                                                        <MDBox display="flex" flexDirection="column" gap={2}>
                                                            <Autocomplete
                                                                options={subEstados}
                                                                getOptionLabel={(option) => option.label || ""}
                                                                value={selectedSubEstado}
                                                                onChange={handleSubEstadoChange}
                                                                disableClearable={false}
                                                                freeSolo={false}
                                                                renderInput={(params) => <TextField {...params} label="Sub Estado *" inputProps={{ ...params.inputProps, readOnly: true }} />}
                                                            />
                                                            <Autocomplete
                                                                options={getEstadosFiltrados()}
                                                                getOptionLabel={(option) => option.label || ""}
                                                                value={selectedEstado}
                                                                onChange={handleEstadoChange}
                                                                disableClearable={false}
                                                                freeSolo={false}
                                                                disabled={!selectedSubEstado}
                                                                renderInput={(params) => <TextField {...params} label="Estado *" inputProps={{ ...params.inputProps, readOnly: true }} />}
                                                            />

                                                            {/* Si RestringePor = "EVENTO", mostrar Tipo de Evento */}
                                                            {restringePorEvento() && (
                                                                <Autocomplete
                                                                    options={getEventosTipoFiltrados()}
                                                                    getOptionLabel={(option) => option.label || ""}
                                                                    value={selectedEventoTipo}
                                                                    onChange={(e, newValue) => setSelectedEventoTipo(newValue)}
                                                                    disableClearable={false}
                                                                    freeSolo={false}
                                                                    disabled={!selectedEstado}
                                                                    renderInput={(params) => (
                                                                        <TextField 
                                                                            {...params} 
                                                                            label="Tipo de Evento *" 
                                                                            inputProps={{ ...params.inputProps, readOnly: true }}
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    '& fieldset': {
                                                                                        borderColor: '#fb8c00',
                                                                                        borderWidth: 2,
                                                                                    },
                                                                                    '&:hover fieldset': {
                                                                                        borderColor: '#f57c00',
                                                                                    },
                                                                                    '&.Mui-focused fieldset': {
                                                                                        borderColor: '#fb8c00',
                                                                                    },
                                                                                    backgroundColor: 'rgba(251, 140, 0, 0.05)',
                                                                                },
                                                                                '& .MuiInputLabel-root': {
                                                                                    color: '#fb8c00',
                                                                                    fontWeight: 'bold',
                                                                                },
                                                                            }}
                                                                            InputProps={{
                                                                                ...params.InputProps,
                                                                                startAdornment: (
                                                                                    <>
                                                                                        <StarIcon sx={{ color: '#fb8c00', mr: 0.5, fontSize: '1.2rem' }} />
                                                                                        {params.InputProps.startAdornment}
                                                                                    </>
                                                                                ),
                                                                            }}
                                                                        />
                                                                    )}
                                                                />
                                                            )}
                                                        </MDBox>
                                                    </MDBox>

                                                    {/* SECCIÓN DESTINO (REQUERIDO) */}
                                                    <MDBox sx={{ borderTop: 2, borderColor: 'divider', pt: 2, mt: 1 }}>
                                                        <MDTypography variant="h6" mb={2} color="success">
                                                            Debe existir el {selectedRestriccionTipo?.restringePor || "Estado/Evento"}
                                                        </MDTypography>

                                                        <MDBox display="flex" flexDirection="column" gap={2}>
                                                            {restringePorEvento() && (
                                                                <>
                                                                    {/* Modo EVENTO: mostrar filtros para evento requerido */}
                                                                    <Autocomplete
                                                                        options={subEstadosRequeridos}
                                                                        getOptionLabel={(option) => option.label || ""}
                                                                        value={selectedSubEstado2}
                                                                        onChange={handleSubEstado2Change}
                                                                        disableClearable={false}
                                                                        freeSolo={false}
                                                                        renderInput={(params) => <TextField {...params} label="Sub Estado *" inputProps={{ ...params.inputProps, readOnly: true }} />}
                                                                    />
                                                                    <Autocomplete
                                                                        options={getEstadosFiltrados2()}
                                                                        getOptionLabel={(option) => option.label || ""}
                                                                        value={selectedEstado2}
                                                                        onChange={handleEstado2Change}
                                                                        disableClearable={false}
                                                                        freeSolo={false}
                                                                        disabled={!selectedSubEstado2}
                                                                        renderInput={(params) => <TextField {...params} label="Estado *" inputProps={{ ...params.inputProps, readOnly: true }} />}
                                                                    />
                                                                    <Autocomplete
                                                                        multiple={!editMode && (selectedRestriccionTipo?.id === 3 || selectedRestriccionTipo?.id === 4)}
                                                                        options={getEventosTipoFiltrados2()}
                                                                        getOptionLabel={(option) => option.label || ""}
                                                                        value={!editMode && (selectedRestriccionTipo?.id === 3 || selectedRestriccionTipo?.id === 4) ? selectedEventoRequerido : (selectedEventoRequerido.length > 0 ? selectedEventoRequerido[0] : null)}
                                                                        onChange={(e, newValue) => {
                                                                            if (!editMode && (selectedRestriccionTipo?.id === 3 || selectedRestriccionTipo?.id === 4)) {
                                                                                // Selección múltiple solo en modo agregar
                                                                                setSelectedEventoRequerido(newValue || []);
                                                                            } else {
                                                                                // Selección simple, convertir a array
                                                                                setSelectedEventoRequerido(newValue ? [newValue] : []);
                                                                            }
                                                                        }}
                                                                        disableClearable={false}
                                                                        freeSolo={false}
                                                                        disabled={!selectedEstado2}
                                                                        renderInput={(params) => (
                                                                            <TextField 
                                                                                {...params} 
                                                                                label="Tipo de Evento Requerido *" 
                                                                                inputProps={{ ...params.inputProps, readOnly: true }}
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-root': {
                                                                                        '& fieldset': {
                                                                                            borderColor: '#fb8c00',
                                                                                            borderWidth: 2,
                                                                                        },
                                                                                        '&:hover fieldset': {
                                                                                            borderColor: '#f57c00',
                                                                                        },
                                                                                        '&.Mui-focused fieldset': {
                                                                                            borderColor: '#fb8c00',
                                                                                        },
                                                                                        backgroundColor: 'rgba(251, 140, 0, 0.05)',
                                                                                    },
                                                                                    '& .MuiInputLabel-root': {
                                                                                        color: '#fb8c00',
                                                                                        fontWeight: 'bold',
                                                                                    },
                                                                                }}
                                                                                InputProps={{
                                                                                    ...params.InputProps,
                                                                                    startAdornment: (
                                                                                        <>
                                                                                            <StarIcon sx={{ color: '#fb8c00', mr: 0.5, fontSize: '1.2rem' }} />
                                                                                            {params.InputProps.startAdornment}
                                                                                        </>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        )}
                                                                    />
                                                                </>
                                                            )}

                                                            {restringePorEstado() && (
                                                                <>
                                                                    {/* Modo ESTADO: solo mostrar selector de estado requerido */}
                                                                    <Autocomplete
                                                                        options={subEstadosRequeridos}
                                                                        getOptionLabel={(option) => option.label || ""}
                                                                        value={selectedSubEstado2}
                                                                        onChange={handleSubEstado2Change}
                                                                        disableClearable={false}
                                                                        freeSolo={false}
                                                                        renderInput={(params) => <TextField {...params} label="Sub Estado *" inputProps={{ ...params.inputProps, readOnly: true }} />}
                                                                    />
                                                                    <Autocomplete
                                                                        options={getEstadosFiltrados2()}
                                                                        getOptionLabel={(option) => option.label || ""}
                                                                        value={selectedEstado2}
                                                                        onChange={(e, newValue) => setSelectedEstado2(newValue)}
                                                                        disableClearable={false}
                                                                        freeSolo={false}
                                                                        disabled={!selectedSubEstado2}
                                                                        renderInput={(params) => <TextField {...params} label="Estado Requerido *" inputProps={{ ...params.inputProps, readOnly: true }} />}
                                                                    />
                                                                </>
                                                            )}
                                                        </MDBox>
                                                    </MDBox>
                                                </>
                                            )}

                                            {/* Campos adicionales */}
                                            <TextField
                                                label="Mensaje de Restricción"
                                                value={mensajeRestriccion}
                                                onChange={(e) => setMensajeRestriccion(e.target.value)}
                                                fullWidth
                                                multiline
                                                rows={3}
                                            />
                                            {/* Grupo OR solo para tipos de restricción 3 y 4 */}
                                            {(selectedRestriccionTipo?.id === 3 || selectedRestriccionTipo?.id === 4) && (
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={grupoOr}
                                                            onChange={(e) => setGrupoOr(e.target.checked)}
                                                            color="info"
                                                        />
                                                    }
                                                    label="Permite Grupos de Eventos"
                                                />
                                            )}
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={activo}
                                                        onChange={(e) => setActivo(e.target.checked)}
                                                        color="info"
                                                    />
                                                }
                                                label="Activo"
                                            />
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="gradient" color="error" onClick={handleCloseDialog}>
                                            Cancelar
                                        </MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleSave}>
                                            Guardar
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Dialog Confirm Delete */}
                                <Dialog
                                    open={openDelete}
                                    onClose={(event, reason) => {
                                        if (reason !== 'backdropClick') {
                                            handleCancelDelete();
                                        }
                                    }}
                                    disableEscapeKeyDown
                                    fullWidth
                                    maxWidth="xs"
                                >
                                    <DialogTitle>Eliminar Restricción</DialogTitle>
                                    <DialogContent>
                                        <MDBox>
                                            <MDTypography>¿Confirma que desea eliminar esta restricción?</MDTypography>
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="gradient" color="error" onClick={handleCancelDelete}>
                                            Cancelar
                                        </MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleConfirmDelete}>
                                            Eliminar
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar}>
                                    <MuiAlert onClose={handleCloseSnackbar} severity={snackbar.severity} elevation={6} variant="filled">
                                        {snackbar.msg}
                                    </MuiAlert>
                                </Snackbar>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default JudEventoRestriccionListar;
